module.exports = __webpack_public_path__ + "static/media/tanker_road_mobile.b8677587.png";